export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/google_earth_pro.00465f7.svg";